import Vue from 'vue'
import App from './App.vue'
import store from "./store";
/* 路由 */
import router from './router'

/* 重置样式 */
import './assets/css/reset.min.css'

/* 字体样式 */
// import './assets/css/font/iconfont.css'

import './assets/lib/bootstrap.min.css'

import { Button,Form ,Field,Image,Tab, Tabs,Checkbox, CheckboxGroup,Tabbar, TabbarItem,NavBar, Empty ,Toast,Divider, Cell,DatetimePicker,Popup ,Calendar ,CountDown,Overlay ,PasswordInput, NumberKeyboard ,Icon,Picker,Uploader  } from 'vant';
import 'vant/lib/index.css';
Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(Image);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(NavBar);
Vue.use(Empty);
Vue.use(Toast);
Vue.use(Divider);
Vue.use( Cell);
Vue.use( DatetimePicker);
Vue.use( Popup);
Vue.use( Calendar); 
Vue.use( CountDown);  
Vue.use( Overlay);  
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
Vue.use(Icon)
Vue.use(Picker)
Vue.use(Uploader)





import './assets/lib/rem'

// tabbar
import TabBar from '@/components/Tabbar.vue'
Vue.component(TabBar.name,TabBar)

Vue.config.productionTip = false

import Navbar from '@/components/NavBar.vue'
Vue.component(Navbar.name,Navbar)

router.beforeEach((to, from, next) => {
  if(to.meta.title){
    document.title = to.meta.title
  }
  next();
});

Vue.prototype.$store = store

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
